import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextTitle3, TextLabel2 } from '@cbhq/cds-web/typography';
import { Pictogram } from '@cbhq/cds-web/illustrations';
import { memo } from 'react';

const ABOUT_TITLE = 'About Tokenized Stocks';

const TokenizedEquitiesAboutContent = memo(function TokenizedEquitiesAboutContent() {
  return (
    <VStack gap={3}>
      {/* Title */}
      <TextTitle3 as="h1" testID="tokenized-equities-about-title">
        {ABOUT_TITLE}
      </TextTitle3>

      {/* Content */}
      <HStack gap={1} alignItems="flex-start">
        <TextLabel2 as="span" color="fgMuted">
          Coinbase Tokenized Stocks brings traditional stocks onto the blockchain for 24/7 trading,
          fractional ownership, and DeFi integration.{' '}
          <TextLabel2 as="a" href="https://docs.verifiedpools.com/pools" color="fgPrimary">
            Learn more
          </TextLabel2>
        </TextLabel2>
        <Pictogram name="tokenBaskets" dimension="48x48" />
      </HStack>
    </VStack>
  );
});

export const TokenizedEquitiesAbout = memo(function TokenizedEquitiesAbout() {
  return (
    <VStack background="bg" borderRadius={300} padding={3}>
      <TokenizedEquitiesAboutContent />
    </VStack>
  );
});
